import { Default } from './chips.default'
import { Menu } from './chips.menu'
import { TChipsProps } from './types'

export const Chips = (props: TChipsProps) => <Default {...props} />

Chips.Default = Default
Chips.Menu = Menu
